/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolHandymanIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-handyman"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M18.6 22.57Q18.6 22.57 18.46 22.57Q18.32 22.57 18.09 22.48Q17.85 22.38 17.65 22.18L13.03 17.52Q12.82 17.32 12.74 17.1Q12.65 16.88 12.65 16.6Q12.65 16.32 12.74 16.1Q12.82 15.88 13.03 15.68L15.65 13.05Q15.85 12.85 16.07 12.76Q16.3 12.68 16.57 12.68Q16.85 12.68 17.07 12.76Q17.3 12.85 17.5 13.05L22.15 17.68Q22.35 17.88 22.45 18.11Q22.55 18.35 22.55 18.63Q22.55 18.9 22.46 19.13Q22.38 19.35 22.18 19.55L19.52 22.2Q19.32 22.4 19.1 22.49Q18.88 22.57 18.6 22.57ZM5.38 22.57Q5.38 22.57 5.24 22.57Q5.1 22.57 4.86 22.48Q4.63 22.38 4.42 22.18L1.82 19.57Q1.63 19.38 1.52 19.14Q1.43 18.9 1.43 18.63Q1.43 18.35 1.52 18.13Q1.63 17.9 1.82 17.7L6.53 13L9.15 13L10.13 12.03L6.33 8.22L4.9 8.22L1.05 4.38L4.33 1.1L8.18 4.95L8.18 6.38L11.97 10.18L14.68 7.47L13.6 6.4L14.68 5.33L12.5 5.33L11.47 4.3L15.47 0.3L16.5 1.32L16.5 3.5L17.57 2.42L21.35 6.2Q21.8 6.65 22.06 7.24Q22.32 7.83 22.32 8.47Q22.32 9.22 21.99 9.9Q21.65 10.57 21.13 11.1L19 8.97L17.6 10.38L16.55 9.32L11 14.88L11 17.48L6.3 22.18Q6.1 22.38 5.88 22.48Q5.65 22.57 5.38 22.57Z" fill={color} />
    </svg>
  );
}
